import { render, staticRenderFns } from "./home-loading.vue?vue&type=template&id=95310a1a&scoped=true&"
import script from "./home-loading.vue?vue&type=script&lang=js&"
export * from "./home-loading.vue?vue&type=script&lang=js&"
import style0 from "./home-loading.vue?vue&type=style&index=0&id=95310a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95310a1a",
  null
  
)

export default component.exports